import React from 'react';
import Style from './style';
import { useChartHelper } from './helper';

const Overview = ({ t = (s) => s, data }) => {
  const { container } = useChartHelper({ data, t });

  return (
    <Style>
      <div className="overview-header">
        <div className="value">
          <p className="main">
            {t('Mine Sites')}
          </p>
          <p>
            {Number(data.mineSites || 0).toLocaleString('en-US')}
          </p>
        </div>
        <div className="value">
          <p className="main">
            {t('Risk Types')}
          </p>
          <p>
            {data.riskTypes || '0 / 56'}
          </p>
        </div>
        <div className="value">
          <p className="main">
            {t('Proponents')}
          </p>
          <p>
            {Number(data.informationSources || 0).toLocaleString('en-US')}
          </p>
        </div>
      </div>
      <div ref={container} style={{ height: 274 }} />
    </Style>
  );
};

export default Overview;
